import { Divisions } from 'src/shared/constants';

import { DamageReportFormKFZWControls } from '../damage-report-form-divisions/damage-report-form-KFZW/damage-report-form-KFZW-controls';
import { FormCollection } from './damage-report-form-factory-types';

export const DamageReportFormsHectorIntance: FormCollection = {
    [Divisions.KFZW]: DamageReportFormKFZWControls,
};
